import { render } from "./ExpenseProjectSummaryTable.vue?vue&type=template&id=33dc1312"
import script from "./ExpenseProjectSummaryTable.vue?vue&type=script&lang=js"
export * from "./ExpenseProjectSummaryTable.vue?vue&type=script&lang=js"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__